import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InboxAppState } from '../reducers/inbox-app.reducer';

const featureState = createFeatureSelector<InboxAppState>('inboxApp');

export const selectInboxAppPageLoading = createSelector(featureState, (state) => state.pageLoading);
export const selectInboxAppMenu = createSelector(featureState, (state) => state.inboxes);
export const selectAllInboxesDetails = createSelector(featureState, (state) => state.inboxDetails);
export const selectInboxAssignees = createSelector(
  featureState,
  (state) => state?.selectedInbox?.assigned_users,
);
export const selectInboxName = createSelector(featureState, (state) => state.selectedInboxName);
export const inboxDetailsSelector = createSelector(featureState, (state) => state.selectedInbox);
export const inboxCategory = createSelector(featureState, (state) => state.selectedCategory);
export const pageNumberSelector = createSelector(featureState, (state) => state.pageNumber);
export const noMoreInboxDataSelector = createSelector(featureState, (state) => state.noMoreInboxes);
